import React, { useState, useEffect, useRef } from "react";
import useRipple from "../../hooks/useRipple";
import "../../hooks/useRipple.css";
import Pagination from "../../shared/components/Pagination/Pagination";
import RefreshIcon from "@mui/icons-material/Refresh";
import MultiSelectCheckbox from "../../shared/components/MultiSelectCheckbox/MultiSelectCheckbox";
import { statusOptions, typeOptions } from "../../constants/bulkJobConstants";

const BulkUploadJobsHeader = ({
  jobId,
  handleJobIdChange,
  isLoading,
  totalItems: totalJobs,
  currentPage,
  itemsPerPage: jobsPerPage,
  handlePageChange,
  handleItemsPerPageChange: handleJobsPerPageChange,
  selectedStatuses,
  handleStatusChange,
  selectedTypes,
  handleTypeChange,
  handleRefresh,
}) => {
  const [searchTerm, setSearchTerm] = useState(jobId);
  const refreshButtonRef = useRef(null);
  useRipple(refreshButtonRef);

  useEffect(() => {
    setSearchTerm(jobId);
  }, [jobId]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleJobIdChange(searchTerm);
    }, 300);

    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [searchTerm, handleJobIdChange]);

  return (
    <>
      <div className="header-container">
        <div className="bulk-upload-jobs-heading">
          <h3>Bulk Upload Jobs</h3>
          <p>Manage your bulk upload jobs</p>
        </div>
      </div>

      <div className="job-id-section">
        <div className="input-section">
          <div className="job-id-input-container">
            <span>Job ID</span>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Enter a Job ID"
            />
          </div>
          <button
            ref={refreshButtonRef}
            className="refresh-btn"
            onClick={handleRefresh}
            disabled={isLoading}
            title="Refresh"
            style={{ position: "relative", overflow: "hidden" }}
          >
            <RefreshIcon />
            <span className="refresh-text">Refresh</span>
          </button>
          <MultiSelectCheckbox
            label="Status"
            options={statusOptions.filter((opt) => opt.value !== "All")}
            selectedValues={selectedStatuses}
            onChange={handleStatusChange}
            placeholder="Select Status"
          />
          <MultiSelectCheckbox
            label="Type"
            options={typeOptions.filter((opt) => opt.value !== "All")}
            selectedValues={selectedTypes}
            onChange={handleTypeChange}
            placeholder="Select Type"
          />
          <Pagination
            totalItems={totalJobs}
            currentPage={currentPage}
            itemsPerPage={jobsPerPage}
            itemsPerPageOptions={[10, 20, 50]}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleJobsPerPageChange}
          />
        </div>
      </div>
    </>
  );
};

export default BulkUploadJobsHeader;
